import { createRoute, lazyRouteComponent } from '@tanstack/react-router';
import { z } from 'zod';

import { defaultPagingSchema } from '../../../helpers/schemas/defaultPagingSchema';
import { serviceSettingsRoute } from '../route';

import { getMobilityApplicationFilterSchema } from './helpers/getMobilityApplicationFilterSchema';
import { mobilityApplicationSortSchema } from './mobilityApplicationSortSchema';

const mobilityApplicationFilterSchema = getMobilityApplicationFilterSchema();

export const mobilityApplicationsRoute = createRoute({
	getParentRoute: () => serviceSettingsRoute,
	path: '/mobility-list',
	component: lazyRouteComponent(
		() => import('./MobilityApplicationsPage'),
		'MobilityApplicationsPage',
	),
	validateSearch: defaultPagingSchema.extend({
		openedMobility: z.string().optional(),
		filter: mobilityApplicationFilterSchema.optional().catch(undefined),
		sort: mobilityApplicationSortSchema,
	}),
});
